import React from 'react';
import { TextElement as TextType } from '../../types/element.types';

interface TextElementProps {
  element: TextType;
}

/**
 * Text/Paragraph Element Renderer
 */
const TextElement: React.FC<TextElementProps> = ({ element }) => {
  return (
    <p
      className="text-element"
      style={element.styles as React.CSSProperties}
    >
      {element.content}
    </p>
  );
};

export default TextElement;

